import { memo } from 'react';
import { Box, Chip, Typography, useTheme } from '@mui/material';

export const ChipsCell = memo(function ChipsCell({
  chips,
}: {
  chips?: Array<{ name?: string }> | unknown;
}) {
  const theme = useTheme();

  if (!chips || !Array.isArray(chips)) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {chips?.length > 0 && (
        <Chip
          label={(chips[0] as { name?: string })?.name}
          size="small"
          sx={{
            backgroundColor:
              theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200',
            color: theme.palette.text.primary,
            fontSize: '0.75rem',
            height: '24px',
            borderRadius: '16px',
            '& .MuiChip-deleteIcon': { fontSize: '16px' },
          }}
        />
      )}

      {chips?.length > 1 && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.875rem',
            color: theme.palette.text.secondary,
          }}
        >
          +{chips.length - 1}
        </Typography>
      )}
    </Box>
  );
});
